import BetaBadge from './BetaBadge';
import type { BetaBadgeProps } from './BetaBadge';

export default BetaBadge;
export type { BetaBadgeProps };
